import { Lead } from '../types'

const API_KEY = 'p72_api_url'

export function getApiUrl(): string {
  return localStorage.getItem(API_KEY) || ''
}

export function setApiUrl(url: string): void {
  localStorage.setItem(API_KEY, url)
}

export async function apiGet(url: string): Promise<Lead[]> {
  const r = await fetch(url)
  const j = await r.json()
  return j.leads || []
}

export async function apiPost(url: string, payload: any): Promise<void> {
  // text/plain evita el preflight CORS con Apps Script
  await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain;charset=utf-8' },
    body: JSON.stringify(payload),
  })
}
